import { z } from "zod";

export const permissionReasonSchema = z.enum([
  "GRANTED",
  "ACCOUNT_REOPEN_REQUIRED",
  "PHYSICAL_LOCATION_UNSUPPORTED",
  "VERIFICATION_STATUS_UNSUPPORTED",
  "RESIDENTIAL_LOCATION_UNSUPPORTED",
  "COOLDOWN",
  "CC_UNVERIFIED_MW_DEP",
  "BLOCKED",
  "CC_LOCATION_ERROR",
  "CC_COOLDOWN",
  "VERIFICATION_STATUS_COOLDOWN",
  "INCOMPLETE_PROFILE",
  "LOGIN_REQUIRED",
  "DENIED",
  "KYC_SUSPENDED",
]);

export type PermissionReason = z.infer<typeof permissionReasonSchema>;

export const permissionTypeSchema = z.enum([
  "viewContest",
  "viewPromotion",
  "viewBettingMarkets",
  "viewEsportsMarkets",
  "viewSportsMarkets",
  "viewRacingMarkets",
  "viewLiveMarkets",
  "viewCasino",
  "viewRSGMessages",
  "playFreeCasino",
  "playPaidCasino",
  "submitBet",
  "submitLiveBet",
  "submitPlaceBet",
  "submitTop4Bet",
  "submitSportsBet",
  "submitEsportsBet",
  "submitSGMBet",
  "submitComboMultiBet",
  "submitPromoComboMultiBet",
  "submitRacingBet",
  "submitInternationalRacingBet",
  "submitSRMBet",
  "submitQuaddieBet",
  "submitRacingExoticBet",
  "submitPromoRacingExoticBet",
  "submitPaidRoster",
  "submitFreeRoster",
  "submitPickems",
  "submitPickemsAwardingPromoCash",
  "submitPickemsAwardingRealCash",
  "deposit",
  "deposit_AUD",
  "deposit_ApplePay",
  "deposit_GooglePay",
  "claimDepositBonus",
  "withdraw",
  "withdraw_AUD",
  "cancelWithdrawal",
  "manageExternalWallet",
  "user",
  "reopenAccount",
  "migratedAccount",
  "cashoutBet",
  "viewCasinoPromotion",
  "claimCasinoPromotion",
]);

export type Permission = z.infer<typeof permissionTypeSchema>;

export const permissionsSchema = z.record(
  permissionTypeSchema,
  permissionReasonSchema,
);

export type Permissions = Partial<Record<Permission, PermissionReason>>;

export const isValidPermission = (value: string): value is Permission => {
  return permissionTypeSchema.safeParse(value).success;
};

export const isValidPermissionReason = (
  value: string,
): value is PermissionReason => {
  return permissionReasonSchema.safeParse(value).success;
};

export const isGranted = (reason: PermissionReason | undefined): boolean => {
  return reason === "GRANTED";
};
